import {
  createUser,
  detailUser,
  searchUser,
  suspendUser,
  updateUser,
  updateUserPassword
} from '../../utils/api';
import { addUserPayload, editUserPayload } from '../../utils/builder/user';
import { CLEAR_MESSAGE, FAILED, LOADING, SET_DATA, SUCCESS } from './constants';

export function fetchSearchUser(params){
  const key = 'search';
  return async(dispatch) => {
    try {
      dispatch({ key, type: LOADING, loading: true });
      const { data } = await searchUser(params);
      dispatch({ key, type: SET_DATA, data });
    } catch (error) {
      dispatch({ key, type: FAILED, message: error.message });
    }
  };
}

export function fetchDetailUser(id){
  const key = 'detail';
  return async(dispatch) => {
    try {
      dispatch({ key, type: LOADING, loading: true });
      const { data } = await detailUser(id);
      dispatch({ key, type: SET_DATA, data });
    } catch (error) {
      dispatch({ key, type: FAILED, message: error.message });
    }
  };
}

export function addUser(payload) {
  const key = 'add';
  return async (dispatch) => {
    dispatch({ key, type: LOADING, loading: true });
    try {
      const { data, message, success } = await createUser(addUserPayload(payload));
      dispatch({ key, type: SET_DATA, data, message, success });
    } catch (error) {
      dispatch({ key, type: FAILED, message: error.message });
    }
  };
}

export function editUser(id, payload, actionType) {
  const key = 'edit';
  return async (dispatch) => {
    dispatch({ key, type: LOADING, loading: true });
    try {
      const { data, message, success } = await updateUser(id, editUserPayload(payload));
      dispatch({ key, type: SET_DATA, data, message, success, actionType });
    } catch (error) {
      dispatch({ key, type: FAILED, message: error.message });
    }
  };
}

export function changeUserPassword(id, payload) {
  return async (dispatch) => {
    dispatch({ type: LOADING, loading: true });
    try {
      await updateUserPassword(id, payload);
      dispatch({ type: SUCCESS, success: true });
    } catch (error) {
      dispatch({ type: FAILED, message: error.message });
    }
  };
}

export function fetchSuspendUser(id) {
  const key = 'suspend';
  return async (dispatch) => {
    dispatch({ key, type: LOADING, loading: true });
    try {
      const { message, success, data } = await suspendUser({ userId: id });
      dispatch({ key, type: SET_DATA, data, message, success });
    } catch (error) {
      dispatch({ key,type: FAILED, message: error.message });
    }
  };
}

export function clearMessage(key) {
  return async (dispatch) => {
    dispatch({ key, type: CLEAR_MESSAGE });
  };
}
